import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { ciAccessControl, ciRoles } from "../../shared/permissions";

/** Better Auth client: sign-in, session, and the admin plugin's user management. */
export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: "/api/auth",
  plugins: [adminClient({ ac: ciAccessControl, roles: ciRoles })],
});

/** The signed-in session, as useSession returns it. */
export type CiSession = NonNullable<
  ReturnType<typeof authClient.useSession>["data"]
>;
